/* ==============================================================================================
 * ISSUER DETAILS MODAL
 * ============================================================================================== */

var Sushi;
var CGS;

(function (Sushi, Plugins, CGS) {
	"use strict";

	var BasePlugin = Plugins.BasePlugin;
	var OffCanvas = Plugins.OffCanvas;
	var Events = Sushi.Events;

	var CabreDetail = function (triggerElement, options) {
		if (Sushi.getPluginInstance("CabreDetail", triggerElement)) {
			return;
		}

		this.element = triggerElement;

		BasePlugin.call(this, this.element, options);

		this.element.setAttribute("href", "#");
		this.element.setAttribute("data-off-canvas-content", "#cabreDetailModal");
		this.element.setAttribute("data-off-canvas-position", "top right");
		this.element.setAttribute("data-off-canvas-from", "right");
		this.element.setAttribute("data-off-canvas-lock-scroll", "true");
		this.element.setAttribute("data-off-canvas-modifiers", "offCanvas medium");
		this.element.setAttribute("data-off-canvas-opens-from-hash", "false");
		this.element.setAttribute("data-off-canvas-close-on-overlay-click", "true");

		this.modal = new OffCanvas(this.element);

		Events(this.modal.element).on("Modal.open", this.handleModalOpen.bind(this));
		Events(this.modal.element).on("Modal.close", this.handleModalClose.bind(this));
	};

	CabreDetail.displayName = "CabreDetail";

	CabreDetail.prototype = Object.create(BasePlugin.prototype);

	var proto = CabreDetail.prototype;

	proto.constructor = CabreDetail;

	proto.handleModalClose = function () {
		this.triggerElement.closest("tr").classList.remove("c-table__row--active");
	};

	proto.handleModalOpen = function () {
		this.triggerElement.closest("tr").classList.add("c-table__row--active");

		var cabre = this.options.cabre;
		var issuerNumber = this.options.issuerNumber;

		var cabreNumberElement = this.modal.element.querySelector("[data-cabre-number]");
		var associatedIssuerTriggerElement = this.modal.element.querySelector("[data-associated-issuer-trigger]");

		cabreNumberElement.innerHTML = cabre;

		associatedIssuerTriggerElement.setAttribute("data-plugin", "AssociatedIssuer");
		associatedIssuerTriggerElement.setAttribute("data-cabre", cabre);
		associatedIssuerTriggerElement.setAttribute("data-issuer-number", issuerNumber);

		// TODO: Update api endpoint URL
		var apiEndpoint = "/json/access/leiSearchCabreDetails.json";

		var tableElement = this.modal.element.querySelector("table");

		var columns = [
			{
				"data": "label",
				"className": "c-table__cell",
			},
			{
				"data": "value",
				"className": "c-table__cell",
			},
		];

		CGS.table(tableElement, {
			ajax: {
				url: apiEndpoint,
				dataSrc: function (json) {
					var data = json.data;

					var cabreData = [
						{
							label: "CABRE",
							value: data.cabre,
						},
						{
							label: "Issuer Number",
							value: data.issuerNumber,
						},
						{
							label: "Legal Entity Name",
							value: data.legalEntityName,
						},
						{
							label: "Role Types",
							value: data.roleTypes,
						},
						{
							type: "empty",
							label: "",
							value: "",
						},
						{
							label: "Address Type",
							value: data.addressType,
						},
						{
							label: "Address",
							value: data.address,
						},
						{
							label: "City",
							value: data.city,
						},
						{
							label: "State",
							value: data.state,
						},
						{
							label: "Postal Code",
							value: data.postalCode,
						},
						{
							label: "Domicile",
							value: data.domicile,
						},
					];

					return cabreData;
				},
			},
			columns: columns,
			columnDefs: [],
			paging: false,
			scrollY: "auto",
			dom: "<'_df _ttu _z10'<'_fxg'><'c-table__export _p0'B>>rt",
			initComplete: function (settings) {
				var scrollHead = settings.nScrollHead;
				var scrollBody = settings.nScrollBody;

				scrollHead.style.display = "none";
				scrollBody.style.overflow = "visible";
				scrollBody.classList.add("_pbxs", "_pb@laptop");
			},
			rowCallback: function (row, data) {
				$(row).addClass("c-table__row--compact");

				if (data.type === "empty") {
					$(row).addClass("c-table__row--empty");
				}
			},
		});
	};

	Plugins.CabreDetail = CabreDetail;
})(Sushi || (Sushi = {}), Sushi.Plugins || (Sushi.Plugins = {}), CGS || (CGS = {}));
